import React, { useEffect, useState, version } from 'react'
import styles from './Search.module.css'
import yearIcon from "../../assets/event_icon.svg"
import monthIcon from "../../assets/month_icon.svg"
import dayIcon from "../../assets/loader_icon.svg"
import eyeIcon from "../../assets/eye-icon.svg"
import searchIcon from "../../assets/search-icon.png"
import downloadIcon from "../../assets/download-icon.png"
import userIcon from "../../assets/user-icon.svg"
import SearchNotFound from "../../assets/search-not-found.gif"
import { useNavigate } from 'react-router-dom'
import { prpHttpAPI } from '../../services/prpHttpAPI'

const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
);

const Search = () => {
    const navigate = useNavigate()
    const [searchTerm, setSearchTerm] = useState("");
    const [searchFlag, setSearchFlag] = useState("");
    const [actionType, setActionType] = useState("plan");
    const [planCount, setPlanCount] = useState(null);
    const [clients, setClients] = useState([])
    const [investments, setInvestments] = useState([]);
    const [planCompletedFlag, setPlanCompletedFlag] = useState(false);
    const [angFlag, setAngFlag] = useState(false);
    const [angPlanCompleteFlag, setAngPlanCompleteFlag] = useState([]);
    const [rMMessage, setRMMessage] = useState("");
    const [loadingStates, setLoadingStates] = useState({});

    const checkUserLogin = async ()=>{
          const localtoken = localStorage.getItem("ssotoken");
          if(!localtoken){
            window.location.href = `${window.location.origin}/login`;
          }
          localStorage.removeItem("userData");
    }

    const getRMDetails = async ()=>{
        const localtoken = localStorage.getItem("ssotoken");
        const result = await prpHttpAPI(null, 'rm-details', localtoken, "POST");
        if(result?.success){
            setPlanCount(result.data)
            console.log("result is", result.data);
        }
            const data ={
          flagType:"default"
            }

        const rmInfo = await prpHttpAPI(data, 'rm-info', localtoken, "POST");
            if(rmInfo?.success){
           // setPlanCount(result.data)
            localStorage.setItem("logged_rm_info", JSON.stringify(rmInfo.data[0]));
           // const isAdmin = rmInfo?.data[0].is_admin_or_not;
            localStorage.setItem('isAdmin',rmInfo.isAdmin);
            console.log("RM info is", JSON.stringify(rmInfo.data[0]));
        }

  }
  useEffect(() => {
    checkUserLogin();
    getRMDetails();
    // Clear previous plan session data on entering search
    localStorage.removeItem("actionType");
    // localStorage.removeItem("userData");
    localStorage.removeItem("planDetails");
    localStorage.removeItem("clientInvestmentData");
    localStorage.removeItem("cashflow");
    localStorage.removeItem("retirementCashflow");
  }, [])

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // en-GB gives dd/mm/yyyy format
  }
  const capitalizeName = (name) => {
    return name
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

           const getCreatedBy = (plan) => {
        if (!plan || typeof plan !== "object") return "-";
        const code = String( plan.spoc_rm || "").trim();
        let name = plan.rm_name || "";

        // spoc_rm_name only if the spoc RM is the same person as the creator code
        if (!name && plan.spoc_rm_name && String(plan.spoc_rm || "").trim() === code) {
            name = plan.spoc_rm_name;
        }

        // logged-in RM's name only if they created this plan
        if (!name && code) {
            const rmInfo = JSON.parse(localStorage.getItem("logged_rm_info") || "{}");
            const loggedCode = String(localStorage.getItem("bCode") || "").trim();
            if (loggedCode === code) name = rmInfo?.EMP_NAME || "";
        }

        if (!name && !code) return "-";
        const displayName = name ? capitalizeName(name) : "";
        return code ? `${displayName} (${code})`.trim() : displayName;
    };

  const handleSearch = async (event) => {
    const value = event.target.value.trim();
    setSearchTerm(value);
    console.log("searchValue", value);

    if (!value) {
      setClients([]); // Clear data if input is empty
      setInvestments([])
      setActionType(""); // Reset action type
      return;
    }

    let flag = ""; // Temporary variable to hold search type

    if (/^PRP\d{7}$/i.test(value)) {
      flag = "plan_id";
    } else if (/^\d{10}$/.test(value)) {
      flag = "phone_number";
    } else if (/^[A-Z0-9]{10}$/i.test(value)) {
      flag = "pan";
    } else {
      console.warn("Invalid search input");
      setClients([]); // Clear data if input is invalid
      setInvestments([]);
      setActionType(""); // Reset action type
      return;
    }

    setSearchFlag(flag); // Update state, but use `flag` instead in this function

    // API call
    try {
      let data = {};
      if (flag === "phone_number") {
        data = { phone_number: value };
      } else if (flag === "pan") {
        data = { pan: value };
        console.log("pan is", data);
      } else if (flag === "plan_id") {
        data = { plan_id: value };
      }

      console.log("data", data);

      const localtoken = localStorage.getItem("ssotoken");
      const result = await prpHttpAPI(data, "search", localtoken, "POST", 'search');

      if (result) {
        console.log("result in search", result);
        if (result.action === "plan") {
          setActionType("plan");
          //////////////////
          const groupedPlans = Object.values(
            result?.data?.planDetails?.reduce((acc, plan) => {
              // Extract base ID before any underscore (if exists)
              const baseId = plan.plan_id.split('_')[0];

              if (!acc[baseId]) {
                acc[baseId] = [];
              }
              acc[baseId].push(plan);
              return acc;
            }, {})
          );
          if (groupedPlans.length > 1) {
            setAngFlag(true);
          }
          const planCompletionStatusArray = groupedPlans.map(group => {
            const lastPlan = group[group.length - 1]; // Last version of this group
            return {
              planCompletedFlag: lastPlan.plan_completed
            };
          });
          console.log("------completeFlag", planCompletionStatusArray);
          setAngPlanCompleteFlag(planCompletionStatusArray)
          console.log('------grouded array------', groupedPlans);

          //////////////////
          setClients(groupedPlans);
          console.log("------res-----", result.data);
          setInvestments(result.data.investmentDetails);
          if (result.data.planDetails[result.data.planDetails.length - 1].plan_completed == true) {
            setPlanCompletedFlag(true);
          } else {
            setPlanCompletedFlag(false);
          }
          console.log("plan is ", result.data.planDetails);
        } else if (result.action === "client") {
          setActionType("client");
          setClients(result.data);
          console.log("client is ", result.data.planDetails);
        } else if (result.action === "different_rm") {
          setActionType("different_rm");
          console.log("action", result.action);
          setRMMessage(result.msg);
          console.log("client with different rm");
        } else {
          setActionType("new_client");
          console.log("new client");
        }
      } else {
        setClients([]); // Clear data if no results found
        setActionType(""); // Reset action type
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
      setClients([]); // Clear data on error
      setActionType(""); // Reset action type
    }
  };

  const handleNewClientClick = () => {
    localStorage.removeItem('userData');
    localStorage.removeItem('clientInvestmentData');
    navigate('/client-details?path=new')
  }
  //////////////////
  const getPdfURL = async (plan_id) => {
    let returnObj = null;
    const data = {
      plan_id: plan_id,
      send_notifications: false
    }
    try {
      const result = await prpHttpAPI(data, 'get-pdf/pdf', null, "POST", null)
      if (result.success) {
        returnObj = result;

      }
    } catch (error) {
      console.log("There is some error after api fetch", error.message);
    }

    return returnObj

  }
  //pdf download
  const donwloadPDF = async (url, plan_id) => {
    //console.log('download pdf function called')
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank"
    link.download = `${plan_id}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    //console.log("pdfUrl", url);

  }
  const handleDownloadPDF = async (plan_id, index) => {
    setLoadingStates(prev => ({ ...prev, [index]: true }));
    try {

      let pdfResult = await getPdfURL(plan_id);
      console.log("download/pdf Response:  ", pdfResult);

      if (!pdfResult?.success) {
        console.log('pdf url is empty');
        return;
      }


      donwloadPDF(pdfResult.url, plan_id);
    } catch (err) {
      console.error("PDF download failed", err);
    } finally {
      setLoadingStates(prev => ({ ...prev, [index]: false }));
    }



  }
  const handleEdit = async (index) => {
    const clientGroup = clients[index];
    if (clientGroup) {
      console.log("client", clientGroup);
      const totalVersions = clientGroup.length;
      const latestClient = clientGroup[totalVersions - 1];
      const fetchData = {
        plan_id: clientGroup[0].plan_id
      }
      localStorage.setItem("userData", JSON.stringify(latestClient));
      /////////////------------
      const localtoken = localStorage.getItem("ssotoken");
      const result = await prpHttpAPI(fetchData, "search", localtoken, "POST", 'search');

      if (result && result.data) {
        console.log("result in ang search", result);
        setInvestments(result.data.investmentDetails);

        const fetchedInvestments = result.data.investmentDetails || [];
        if (fetchedInvestments.length > 0) {
          localStorage.setItem("clientInvestmentData", JSON.stringify(fetchedInvestments[fetchedInvestments.length - 1]));
        }
      }
      ////////////

      navigate('/client-details?path=edit');
    }
  };
  const handleEyeClick = (plan_id, versions, index) => {
    const clientGroup = clients[index];
    if (!clientGroup) return;

    let planID = "";
    let editableID = "";
    let editableData = {};

    const totalVersions = clientGroup.length;

    if ((angFlag ? angPlanCompleteFlag[index].planCompletedFlag : planCompletedFlag) && totalVersions > 1) {
      planID = `${plan_id}_${totalVersions}`;
      editableID = `${plan_id}_${totalVersions}`;
    } else if ((angFlag ? angPlanCompleteFlag[index].planCompletedFlag : planCompletedFlag) && totalVersions === 1) {
      planID = plan_id;
      editableID = `${plan_id}_${totalVersions}`;
    } else if (!(angFlag ? angPlanCompleteFlag[index].planCompletedFlag : planCompletedFlag) && totalVersions === 2) {
      planID = plan_id;
      editableID = `${plan_id}_2`;
      editableData = clientGroup[1];
    } else if (!(angFlag ? angPlanCompleteFlag[index].planCompletedFlag : planCompletedFlag) && totalVersions > 2) {
      planID = `${plan_id}_${totalVersions - 1}`;
      editableID = `${plan_id}_${totalVersions}`;
      editableData = clientGroup[totalVersions - 1];
    } else {
      return;
    }

    // localStorage.removeItem("plan_id");
    // Use the latest *completed* version's record as the base so clinical fields
    // (age, retirementAge, inflation_rate …) match the plan being viewed, not v1.
    const latestCompletedRecord = (angFlag ? angPlanCompleteFlag[index].planCompletedFlag : planCompletedFlag)
      ? clientGroup[totalVersions - 1]
      : (totalVersions > 1 ? clientGroup[totalVersions - 2] : clientGroup[0]);
    localStorage.setItem("userData", JSON.stringify({ ...latestCompletedRecord, plan_id: planID }));
    localStorage.setItem("versions", versions);
    localStorage.setItem("editableID", editableID);
    localStorage.setItem("planCompletedFlag", JSON.stringify((angFlag ? angPlanCompleteFlag[index].planCompletedFlag : planCompletedFlag)));
    localStorage.setItem("editableData", JSON.stringify(editableData));

    navigate('/plan-output', { state: { from: "search" } });
  };

  return (
    <>
      <div className={styles.main}>
        <div>
          <p className={styles.heading}>Total <span className={styles.highlighted}>Plans</span> Created </p>
        </div>
        <div className={styles.cards}>
          <div className='card  p-4'>
            <div className={`d-flex justify-content-between  ${styles.cardTop}`}>
              {planCount?.yearlyCount != null ? <span>{planCount.yearlyCount}</span> :
                <div className={` spinner-border  ${styles.loaderDiv} `} style={{ color: '#6fa287' }} role="status">
                  <span className="sr-only"></span>
                </div>}
              <span><img src={yearIcon} alt="Year-icon" /></span>
            </div>
            <div className={styles.cardBottom}>Year to date</div>
          </div>
          <div className='card  p-4'>
            <div className={`d-flex justify-content-between  ${styles.cardTop}`}>
              {planCount?.monthlyCount != null ? <span>{planCount.monthlyCount}</span> : <div className={` spinner-border ${styles.loaderDiv}`} style={{ color: '#6fa287' }} role="status">
                <span className="sr-only"></span>
              </div>}
              <span><img src={monthIcon} alt="Month-icon" /></span>
            </div>
            <div className={styles.cardBottom}>Month to date</div>
          </div>
          <div className='card  p-4'>
            <div className={`d-flex justify-content-between  ${styles.cardTop}`}>
              {planCount?.yesterdayCount != null ? <span>{planCount.yesterdayCount}</span> : <div className={` spinner-border  ${styles.loaderDiv}`} style={{ color: '#6fa287' }} role="status">
                <span className="sr-only"></span>
              </div>}
              <span><img src={dayIcon} alt="Day-icon" /></span>
            </div>
            <div className={styles.cardBottom}>Yesterday</div>
          </div>

        </div>
        <div className={styles.searchTab}>
          <div>
            <input type="text" placeholder='Search by Mobile No., PAN No. or Plan ID' onChange={handleSearch} />
            <span><img src={searchIcon} alt="SearchIcon" /></span>
          </div>
          <button className={styles.addClientBtn} onClick={handleNewClientClick}>+ Add new client</button>
        </div>
        <div className={styles.clientDiv}>
          <div className={`d-flex justify-content-between mb-3 ${styles.clientHeading}`}>
            {actionType == 'plan' && clients?.length > 0 && <span>All Plans Created</span>}

            {actionType == 'client' && clients?.length > 0 && <span className={styles.searchDivHeading}>Search result "1"</span>}
            {(actionType == 'different_rm' || actionType == 'new_client') && <span className={styles.searchDivHeading}>Search result "0"</span>}
            {/* {actionType=="plan" && <button className='btn btn-outline-danger'><span className='me-1'> <img src={downloadIcon} alt="download-icon" /></span> Download CSV</button>} */}
          </div>
          {/* action = plan */}
          {/* {clients?.length>0 && clients[0] && actionType=="plan" && 
             <div className={styles.clientList}>
           { <div className={`card p-3 my-4 ${styles.cardDiv}`} > 
                   <div className='row'>
                       <div className='col d-flex'><span><img src={userIcon} alt="userIcon" /></span> <div className='d-inline-flex flex-column ms-3'><span className='mb-1'><b>{capitalizeName(clients[0].client_name)}</b></span><span className={styles.smallDiv}>+91-{clients[0].phone_number}</span></div></div>
                       <div className='col d-inline-flex flex-column '><span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>PAN No.</span><span className={`${styles.spanDiv}`}><b>{clients[0].pan_number}</b></span></div>
                       <div className='col d-inline-flex flex-column '><span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>Plan Id</span><span className={`${styles.spanDiv}`}><b>{clients[0].plan_id}</b></span></div>
                       <div className='col d-inline-flex flex-column '><span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>Version</span><span className={`${styles.spanDiv}`}><b>{planCompletedFlag?clients.length:clients.length-1}</b></span></div>
                       <div className='col d-flex justify-content-end'>
                     {  (localStorage.getItem('bCode') == clients[0].rm_code) && <button  className='btn' onClick={()=>handleEdit(`${clients[0].plan_id}_${clients.length}`)}>Edit</button>} 
                        <span className={!planCompletedFlag && clients.length==1 && 'd-none'} ><img onClick={()=>handleEyeClick(clients[0].plan_id, planCompletedFlag? clients.length:clients.length-1)} className={styles.eyeIcon} src={eyeIcon} alt="eye-icon" /></span></div>
                   
                   </div>
                   <div className={`row pt-3 d-flex justify-content-between  ${styles.cardDate}`}>
                       <span className=' w-25 text-start'><span>Plan creation date :</span> {formatDate(clients[0].created_at)}</span>
                       <span className=' w-25 text-end'><span>Revision date :</span> {planCompletedFlag? formatDate(clients[clients.length-1].updated_at): (clients.length>1 ? formatDate(clients[clients.length-2].updated_at): "")}</span>
                   </div>
               </div> 
           }
           mobile view
                      { <div className={`card p-3 my-4 ${styles.mobileCardDiv}`} > 
                   <div className='col'>
                       <div className=''><span><img src={userIcon} alt="userIcon" /></span> <div className='d-inline-flex flex-column ms-4'><span className='mb-1'><b>{capitalizeName(clients[0].client_name)}</b></span><span className={styles.smallDiv}>+91-{clients[0].phone_number}</span></div></div>
                       <div className='row d-flex flex-row '><span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>PAN No.</span><span className={`${styles.spanDiv}`}><b>{clients[0].pan_number}</b></span></div>
                       <div className='row d-inline-flex flex-row '><span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>Plan Id</span><span className={`${styles.spanDiv}`}><b>{clients[0].plan_id}</b></span></div>
                       <div className='row d-inline-flex flex-row '><span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>Version</span><span className={`${styles.spanDiv}`}><b>{planCompletedFlag?clients.length:clients.length-1}</b></span></div>
                       <div className=' m-2'>
                       { (localStorage.getItem('bCode') == clients[0].rm_code) && <button className='btn' onClick={()=>handleEdit(`${clients[0].plan_id}_${clients.length}`)}>Edit</button>} 
                        <span className={!planCompletedFlag && clients.length==1 && 'd-none'}  ><img onClick={()=>handleEyeClick(clients[0].plan_id, planCompletedFlag? clients.length:clients.length-1)} className={styles.eyeIcon} src={eyeIcon} alt="eye-icon" /></span>
                        </div>
                   
                   </div>
                   <div className={`row pt-3 d-flex justify-content-between  ${styles.cardDate}`}>
                       <span className=' w-50 text-start'><span>Plan creation date :</span> {formatDate(clients[0].created_at)}</span>
                       <span className=' w-50 text-end'><span>Revision date :</span> {planCompletedFlag? formatDate(clients[clients.length-1].updated_at): (clients.length>1 ? formatDate(clients[clients.length-2].updated_at): "")}</span>
                   </div>
               </div> 
           }
           </div> } */}
          {clients?.length > 0 && Array.isArray(clients[0]) && actionType === "plan" && (
            <div className={styles.clientList}>
              {clients.map((clientGroup, index) => {
                console.log("clientssssss", clients);
                const client = clientGroup[0]; // First version only
                console.log('client is', client);
                const totalVersions = clientGroup.length;
                const latestPlan = angFlag ? (angPlanCompleteFlag[index].planCompletedFlag ? clientGroup[totalVersions - 1] : (totalVersions > 1 ? clientGroup[totalVersions - 2] : "")) : (planCompletedFlag ? clientGroup[totalVersions - 1] : (totalVersions > 1 ? clientGroup[totalVersions - 2] : ""));
                console.log("latest", latestPlan);

                return (
                  <>
                    <div key={index} className={`card p-3 my-4 ${styles.cardDiv}`}>
                      <div className='row'>
                        <div className='col d-flex'>
                          <span><img src={userIcon} alt="userIcon" /></span>
                          <div className='d-inline-flex flex-column ms-3'>
                            <span className='mb-1'><b>{capitalizeName(client.client_name)}</b></span>
                            <span className={styles.smallDiv}>+91-{client.phone_number}</span>
                          </div>
                        </div>
                        <div className='col d-inline-flex flex-column'>
                          <span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>PAN No.</span>
                          <span className={`${styles.spanDiv}`}><b>{client.pan_number}</b></span>
                        </div>
                        <div className='col d-inline-flex flex-column'>
                          <span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>Plan Id</span>
                          <span className={`${styles.spanDiv}`}><b>{client.plan_id}</b></span>
                        </div>
                        <div className='col d-inline-flex flex-column'>
                          <span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>Version</span>
                          <span className={`${styles.spanDiv}`}><b>{latestPlan.plan_completed ? totalVersions : totalVersions - 1}</b></span>
                        </div>
                        <div className='col d-inline-flex flex-column'>
                          <span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>Created By</span>
                          <span className={`${styles.spanDiv} ${styles.createdBy}`}><b>{getCreatedBy(client)}</b></span>
                        </div>
                        <div className='col d-flex justify-content-end align-items-center'>

                          <span
                            onClick={() => handleEdit(index)}
                            className={styles.editIcon}
                            title="Edit"
                          >
                            <EditIcon />
                          </span>
                          <span className={angFlag ? (!angPlanCompleteFlag[index].planCompletedFlag && totalVersions === 1 ? 'd-none' : '') : (!planCompletedFlag && totalVersions === 1 ? 'd-none' : '')}>
                            <img
                              onClick={() => handleEyeClick(client.plan_id, (latestPlan.plan_completed ? totalVersions : totalVersions - 1), index)}
                              className={styles.eyeIcon}
                              src={eyeIcon}
                              alt="eye-icon"
                            />
                          </span>
                          <span className={angFlag ? (!angPlanCompleteFlag[index].planCompletedFlag && totalVersions === 1 ? 'd-none' : '') : (!planCompletedFlag && totalVersions === 1 ? 'd-none' : '')}>
                            {loadingStates[index] ?
                              <div className={` spinner-border ${styles.loaderdiv}`} style={{ color: '#6fa287' }} role="status">
                                <span className="sr-only"></span>
                              </div> : <img
                                onClick={() => handleDownloadPDF(latestPlan.plan_id, index)}
                                src={downloadIcon}
                                className={styles.donwloadPDF}
                                alt="download-icon"
                              />}


                          </span>

                        </div>
                      </div>
                      <div className={`row pt-3 d-flex justify-content-between ${styles.cardDate}`}>
                        <span className='w-25 text-start'>
                          <span className={styles.dateTooltip} title="Plan creation date">{formatDate(client.created_at)}</span>
                        </span>
                        <span className='w-25 text-end'>
                          {latestPlan && <span className={styles.dateTooltip} title="Revision date">{formatDate(latestPlan.updated_at)}</span>}
                        </span>
                      </div>
                    </div>
                    {/* mobile view */}
                    <div className={`card p-3 my-4 ${styles.mobileCardDiv}`} >
                      <div className='col'>
                        <div className=''><span><img src={userIcon} alt="userIcon" /></span> <div className='d-inline-flex flex-column ms-4'><span className='mb-1'><b>{capitalizeName(client.client_name)}</b></span><span className={styles.smallDiv}>+91-{client.phone_number}</span></div></div>
                        <div className='row d-flex flex-row '><span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>PAN No.</span><span className={`${styles.spanDiv}`}><b>{client.pan_number}</b></span></div>
                        <div className='row d-inline-flex flex-row '><span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>Plan Id</span><span className={`${styles.spanDiv}`}><b>{client.plan_id}</b></span></div>
                        <div className='row d-inline-flex flex-row '><span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>Version</span><span className={`${styles.spanDiv}`}><b>{latestPlan.plan_completed ? totalVersions : totalVersions - 1}</b></span></div>
                        <div className='row d-inline-flex flex-row '><span className={`${styles.spanDiv} ${styles.smallDiv} mb-1`}>Created By</span><span className={`${styles.spanDiv}`}><b>{getCreatedBy(client)}</b></span></div>
                        <div className=' m-2'>
                          <span className={styles.editIcon} onClick={() => handleEdit(index)} title="Edit">
                            <EditIcon />
                          </span>

                          <span className={angFlag ? (!angPlanCompleteFlag[index].planCompletedFlag && totalVersions === 1 ? 'd-none' : '') : (!planCompletedFlag && totalVersions === 1 ? 'd-none' : '')}>
                            <img
                              onClick={() => handleEyeClick(client.plan_id, (latestPlan.plan_completed ? totalVersions : totalVersions - 1), index)}
                              className={styles.eyeIcon}
                              src={eyeIcon}
                              alt="eye-icon"
                            />
                          </span>
                          <span className={angFlag ? (!angPlanCompleteFlag[index].planCompletedFlag && totalVersions === 1 ? 'd-none' : '') : (!planCompletedFlag && totalVersions === 1 ? 'd-none' : '')}>
                            {loadingStates[index] ?
                              <div className={` spinner-border ${styles.loaderdiv}`} style={{ color: '#6fa287' }} role="status">
                                <span className="sr-only"></span>
                              </div> : <img
                                onClick={() => handleDownloadPDF(latestPlan.plan_id, index)}
                                src={downloadIcon}
                                className={styles.donwloadPDF}
                                alt="download-icon"
                              />}


                          </span>
                        </div>

                      </div>
                      <div className={`row pt-3 d-flex justify-content-between  ${styles.cardDate}`}>
                        <span className=' w-50 text-start'>
                          <span className={styles.dateTooltip} title="Plan creation date">{formatDate(client.created_at)}</span>
                        </span>
                        <span className=' w-50 text-end'>
                          {latestPlan && <span className={styles.dateTooltip} title="Revision date">{formatDate(latestPlan.updated_at)}</span>}
                        </span>
                      </div>
                    </div>
                  </>
                );
              })}



            </div>
          )}

          {/* action = client */}
          {clients?.length > 0 && clients[0] && actionType == "client" && <div className={`card py-4 px-3 my-4 ${styles.cardDiv}`} >
            <div className='row'>
              <div className='col d-flex'><span><img src={userIcon} alt="userIcon" /></span> <div className='d-inline-flex flex-column ms-3'><span className='mb-1'><b>{clients[0][1]}</b></span><span className={styles.smallDiv}>+91-{clients[0][19]}</span></div></div>
              <div className='col d-inline-flex flex-column '><span className={` ${styles.smallDiv} mb-1`}>PAN No.</span><span className={``}><b>{clients[0][23]}</b></span></div>
              <div className='col d-flex justify-content-end'><button onClick={handleNewClientClick} className='btn'>Create New</button> </div>
            </div>
          </div>}
          {/* mobile view */}
          {clients?.length > 0 && clients[0] && actionType == "client" && <div className={`card py-4 px-3 my-4 ${styles.mobileCardDiv}`} >
            <div className='row'>
              <div className='d-flex'><span><img src={userIcon} alt="userIcon" /></span> <div className='d-inline-flex flex-column ms-3'><span className='mb-1'><b>{clients[0][1]}</b></span><span className={styles.smallDiv}>+91-{clients[0][19]}</span></div></div>
              <div className='d-inline-flex flex-column '><span className={` ${styles.smallDiv} mb-1`}>PAN No.</span><span className={``}><b>{clients[0][23]}</b></span></div>
              <div className='d-inline-flex'><button onClick={handleNewClientClick} className='btn w-100 mx-4 my-3'>Create New</button> </div>
            </div>
          </div>}


          {/* action = no_client */}
          {actionType == "new_client" && <div className={`d-flex flex-column align-items-center ${styles.searchNotFoundDiv}`}>
            <img src={SearchNotFound} alt="search-not-found" />
            <p>No Data Found</p>
          </div>}
        </div>
      </div>
    </>
  )
}

export default Search